import Vue from 'vue'
import Vuex from 'vuex'
import User from './modules/user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    navigation: [
      {
        name: '熊猫抓抓管理平台',
        url: '/home',
        logo: 'fa-dashboard'
      },
      {
        name: '游戏设备管理',
        logo: 'fa-gamepad',
        childrens: [
          {
            name: '游戏房间管理',
            url: '/rooms'
          },
          {
            name: '概率控制管理',
            url: '/rooms/trigger'
          }
        ]
      },
      {
        name: '订单管理',
        logo: 'fa-shopping-bag',
        childrens: [
          {
            name: '游戏订单',
            url: '/shop/orders'
          },
          {
            name: '游戏记录',
            url: '/rooms/sessions'
          }
        ]
      },
      {
        name: '游戏玩家',
        logo: 'fa-user-plus',
        childrens: [
          {
            name: '玩家列表',
            url: '/gameusers'
          },
          {
            name: '玩家游戏币流水',
            url: '/gameusers/coin/journal'
          }
        ]
      },
      {
        name: '账号管理',
        logo: 'fa-cogs',
        childrens: [
          {
            name: '密码修改',
            url: '/user/password'
          },
          {
            name: '开放平台信息',
            url: '/application'
          }
        ]
      }
    ],
    pageData: {
      title: '',
      brief: '',
      pathlist: []
    }
  },
  mutations: {
    setPageData (state, pageData) {
      state.pageData = pageData
    }
  },
  modules: {
    User
  },
  strict: debug,
  plugins: debug ? [] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js